/* T.LUXY: accessible Women/Men desktop navigation tabs.
 * If JS fails, the Women links remain visible; the original mobile navigation is unaffected.
 */
(() => {
  'use strict';
  function initLocalization() {
    document.querySelectorAll('.tluxy-safe-header__localization select[data-tluxy-localization-select]').forEach(select => {
      if (select.dataset.tluxyBound === 'true') return;
      select.dataset.tluxyBound = 'true';
      select.addEventListener('change', () => {
        // Native Shopify localization form contains the anti-forgery token.
        if (select.form) select.form.submit();
      });
    });
  }
  function init() {
    initLocalization();
    const container = document.querySelector('[data-tluxy-header-departments]');
    const nav = document.querySelector('[data-tluxy-header-categories]');
    if (!container || !nav || container.dataset.tluxyReady === 'true') return;
    const tabs = Array.from(container.querySelectorAll('[data-tluxy-dept]'));
    const panels = Array.from(nav.querySelectorAll('[data-tluxy-dept-panel]'));
    if (tabs.length !== 2 || panels.length !== 2) return;
    function activate(value, focus) {
      tabs.forEach(tab => {
        const selected = tab.dataset.tluxyDept === value;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (focus && selected) tab.focus();
      });
      panels.forEach(panel => panel.hidden = (panel.dataset.tluxyDeptPanel !== value));
    }
    container.addEventListener('click', e => {
      const tab = e.target.closest('[data-tluxy-dept]');
      if (tab && container.contains(tab)) activate(tab.dataset.tluxyDept, false);
    });
    container.addEventListener('keydown', e => {
      const tab = e.target.closest('[data-tluxy-dept]');
      if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      e.preventDefault();
      const index = tabs.indexOf(tab);
      const next = e.key === 'Home' ? 0 : e.key === 'End' ? 1
        : e.key === 'ArrowLeft' ? (index + 1) % 2 : (index + 1) % 2;
      activate(tabs[next].dataset.tluxyDept, true);
    });
    if (/\/collections\/(?:all-men|men-|trousers|sneakers)(?:\/|$)/.test(window.location.pathname)) {
      activate('men', false);
    }
    container.dataset.tluxyReady = 'true';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
